module.exports = __webpack_public_path__ + "static/media/award-03.26584fa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/award-03.png
// module id = 495
// module chunks = 0